import config from '../config';
import React, { PureComponent } from 'react';
import { ApolloProvider } from 'react-apollo';
import { ApolloProvider as ApolloHooksProvider } from '@apollo/react-hooks';
import { createUploadLink } from 'apollo-upload-client/lib';
import { ApolloClient } from 'apollo-client';
import {
  authMiddleware,
  updateMiddleware,
  errorHandler,
} from '../utils/graphql';
import { InMemoryCache } from 'apollo-cache-inmemory';
import withKeycloak from '../keycloak/WithKeycloak';

import { ApolloLink } from 'apollo-link';
import { withClientState } from 'apollo-link-state';
import { onError } from 'apollo-link-error';
import venta from './resolvers/venta';

import App2 from './App2';

import { Provider } from 'react-redux';
import configureStore from '../store/configureStore';
import { ConfigProvider } from 'antd/lib';
import es_ES from 'antd/es/locale/es_ES';

import 'moment/locale/es';
import moment from 'moment';
moment.locale('es');

import '@ant-design/compatible/assets/index.css';

//Redux
const store = configureStore();

class App extends PureComponent {
  render() {
    //Apollo
    const cache = new InMemoryCache({
      dataIdFromObject: o => o._id,
    });

    const stateLink = withClientState({ cache, ...venta });
    const catchError = onError(error => {
      if (
        error.graphQLErrors[0].message ===
        'Context creation failed: [ERROR: INVALID TOKEN]'
      ) {
        console.info('<--"ERROR"-->');
        console.log('ERROR');
        console.info('<--/"ERROR"-->');

        window.location.reload(false);
      }
    });
    const linkUpload = createUploadLink({ uri: config.api.url });
    const keycloak = this.props.authenticator.keycloak;
    const token = this.props.authenticator.keycloak.token;
    const client = new ApolloClient({
      cache,
      link: catchError.concat(
        ApolloLink.from([
          stateLink,
          updateMiddleware(keycloak),
          authMiddleware(keycloak),
          errorHandler(keycloak),
          linkUpload,
        ])
      ),
    });

    const { authenticator } = this.props;

    return (
      <ApolloProvider client={client}>
        <ApolloHooksProvider client={client}>
          <ConfigProvider locale={es_ES}>
            <Provider store={store}>
              <App2 authenticator={authenticator} />
            </Provider>
          </ConfigProvider>
        </ApolloHooksProvider>
      </ApolloProvider>
    );
  }
}

export default withKeycloak(App);
